import { createFileRoute, useParams } from "@tanstack/react-router";
import { createTicketAttachmentsListQueryOptions } from "@/features/attachments/adapters/ticket-attachments-adapter";
import { TicketAttachmentsWorkspace } from "@/features/attachments/components/ticket-attachments-workspace";
import { ATTACHMENTS_FILES_PAGE_SIZE } from "@/features/attachments/types";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/tickets/(ticket)/$ticketId/workspace/attachments",
)({
	loader: ({ context, params }) =>
		context.queryClient.ensureQueryData(
			createTicketAttachmentsListQueryOptions({
				ticketId: params.ticketId,
				organizationId: params.orgId,
				start: 1,
				count: ATTACHMENTS_FILES_PAGE_SIZE,
			}),
		),
	component: TicketWorkspaceAttachmentsTab,
});

/**
 * Job workspace Attachments tab — thin route adapter.
 */
function TicketWorkspaceAttachmentsTab() {
	const params = useParams({
		from: "/_authenticated/(web-app)/_web/web/$orgId/tickets/(ticket)/$ticketId/workspace/attachments",
	});

	return (
		<TicketAttachmentsWorkspace
			orgId={params.orgId}
			ticketId={params.ticketId}
		/>
	);
}
